import {
  Button, Collapse, Text, useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import { useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { setFieldInputStyles } from '../../formSlice';
import ColorField from '../../../ColorField';

const AlwaysScrollToBottom = () => {
  const elementRef = useRef();
  useEffect(() => { setTimeout(() => elementRef.current.scrollIntoView({ behavior: 'smooth' }), 10); }, []);
  return <div ref={elementRef} />;
};

const MoreInputStyles = ({ design }) => {
  const { isOpen, onToggle } = useDisclosure();
  const dispatch = useDispatch();

  return (
    <>
      <Button variant="ghost" size="sm" onClick={onToggle} colorScheme="blue" hidden={isOpen}>Show more</Button>
      <Collapse
        in={isOpen}
        animateOpacity
        style={{ width: '100%' }}
        transition={{ exit: { delay: 0, duration: 0 }, enter: { duration: 0 } }}
        unmountOnExit
      >
        <VStack color="gray.600" fontSize="sm" gap="3">
          <Text fontWeight="bold">Input hover</Text>
          <ColorField
            label="Background"
            color={get(design, 'fields.input.hover.bgcolor')}
            onChange={(color) => dispatch(setFieldInputStyles({ hover: { bgcolor: color } }))}
          />
          <ColorField
            label="Border color"
            color={get(design, 'fields.input.hover.borderColor')}
            onChange={(color) => dispatch(setFieldInputStyles({ hover: { borderColor: color } }))}
          />
          <ColorField
            label="Text color"
            color={get(design, 'fields.input.hover.color')}
            onChange={(color) => dispatch(setFieldInputStyles({ hover: { color } }))}
          />
          <Text fontWeight="bold">Input focus</Text>
          <ColorField
            label="Background"
            color={get(design, 'fields.input.focus.bgcolor') || ''}
            onChange={(color) => dispatch(setFieldInputStyles({ focus: { bgcolor: color } }))}
          />
          <ColorField
            label="Border color"
            color={get(design, 'fields.input.focus.borderColor') || ''}
            onChange={(color) => dispatch(setFieldInputStyles({ focus: { borderColor: color } }))}
          />
          <ColorField
            label="Text color"
            color={get(design, 'fields.input.focus.color') || ''}
            onChange={(color) => dispatch(setFieldInputStyles({ focus: { color } }))}
          />
        </VStack>
        <Button size="sm" mt="2" variant="ghost" onClick={onToggle} colorScheme="blue">Show less</Button>
        <AlwaysScrollToBottom />
      </Collapse>
    </>
  );
};
export default MoreInputStyles;
